import React, { useState, useEffect, useCallback, lazy, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { controlPanelSidebarOpenComponent, controlPanelSidebarClose } from "@/redux/actions/controlPanelSidebarAction"
import { urlPath } from "@/utils"


const importView = (icon) => lazy(() => import(`@/assets/icons/${icon}`).catch(() => console.log("import error")))
const useStyles = makeStyles((theme) => ({
    iconWrapper: {
        cursor: "pointer",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            "& $labelWrapper": {
                clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)",
            },
        },
    },
    icon: {
        position: "relative",
        zIndex: "3",
    },
    iconInnerWrapper: {
        display: "flex",
    },
    labelWrapper: {
        display: "flex",
        position: "absolute",
        top: "8px",
        right: 0,
        textTransform: "uppercase",
        overflow: "hidden",
        background: theme.palette.primary.main,
        color: "#ffffff",
        alignItems: "center",
        justifyContent: "center",
        whiteSpace: "nowrap",
        transition: "0.3s ease-out",
        clipPath: "polygon(100% 0,100% 0,100% 100%,100% 100%)",
        "&>p": {
            padding: theme.spacing(3),
            paddingRight: "65px",
        },
    },
}))

const ControlPanelSidebarAction = memo((props) => {
    const { icon, label, type, handleModalCompleteProjectShowChange } = props
    const navigate = useNavigate()
    const classes = useStyles()
    const [views, setViews] = useState([])
    const { user } = useSelector((state) => state.userReducer)

    const loadViews = async () => {
        const componentPromises = async () => {
            const View = await importView(icon)
            return <View className={classes.icon} width="32" fill="white" key={label} />
        }
        const view = await componentPromises()
        setViews(view)
    }

    useEffect(() => {
        loadViews()
    }, [])

    const dispatch = useDispatch()
    const controlPanelSidebarStatus = useSelector((state) => state.controlPanelSidebarReducer)

    const handleSidebarOpen = useCallback(() => {
        dispatch(controlPanelSidebarOpenComponent(type))
    }, [controlPanelSidebarStatus])

    const handleOnClick = useCallback(() => {
        if (type === "back") {
            const path = urlPath("dashboard", user.userId)
            navigate(path)
        } else if (type === process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PROJECT_COMPLETE) {
            // complete project
            handleModalCompleteProjectShowChange(true)
        } else {
            // project setting or add participant
            handleSidebarOpen()
        }
    }, [type])

    return (
        <React.Suspense fallback={null}>
            <Box px={2} py={3} className={classes.iconWrapper} onClick={handleOnClick}>
                <Box className={classes.iconInnerWrapper}>{views}</Box>
                <Box className={classes.labelWrapper}>
                    <Typography>{label}</Typography>
                </Box>
            </Box>
        </React.Suspense>
    )
})

export default ControlPanelSidebarAction
